export const keycloakState = {
	Loading: 'loading',
	Authenticated: 'authenticated',
	Unauthenticated: 'unauthenticated',
	Failed: 'failed'
} as const;

/**
 * Query parameter used to indicate that the user is currently in a login flow.
 * This is used to redirect the user to the correct page after being redirected from Keycloak.
 */
export const LOGIN_FLOW_QUERY_PARAM = 'loginflow' as const;
